module.exports = __webpack_public_path__ + "static/IBMPlexMono-Regular-c7832ed5479c8b9eb5c4733047ecacbd.woff2";